<template>
  <v-menu class="menu-processes" :close-on-content-click="false" left bottom transition="scale-transition"
    v-if="$auth.ensure('SCRAPPING_PRODUCT')">
    <template v-slot:activator="{ on }">
      <v-btn small fab :color="$auth.ensure('DARK_MODE') ? 'black' : 'white'" v-on="on">
        <v-icon>mdi-progress-clock</v-icon>
      </v-btn>
    </template>
    <v-card class="big-box">
      <v-card-title class="box">Suivi des processus en cours</v-card-title>
      <v-card-text class="box" v-if="loading"> <v-progress-circular indeterminate
          color="black"></v-progress-circular>recherche en cours....</v-card-text>
      <v-card-text class="box" v-else-if="!loading && !getProcesses">Aucun process en cours</v-card-text>
      <v-card-text v-else-if="getProcesses && Object.keys(getProcesses).length" class="pa-0">
        <div v-for="(keyProcess, i) in Object.keys(getProcesses).reverse()" :key="i">
          <process-item :process="getProcesses[keyProcess]" :type="'navbar'"
            :processName="getProcesses[keyProcess].processName"></process-item>
        </div>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import CHECK_PROCESS_PROGRESS from "../../graphql/product/check-process-progress.gql";
import FOLLOW_PROCESS_PROGRESS from "../../graphql/product/follow-process-progress.gql";
import { mapActions, mapGetters } from "vuex";
import processItem from "./processItem.vue";
export default {
  components: { processItem },
  data() {
    return {
      loading: false,
      menu: false,
      progressProcesses: [],
      count: 0,
      decrement: false
    };
  },
  computed: {
    ...mapGetters({
      getProcesses: "getProcesses",
    }),
  },
  props: [],
  watch: {},
  methods: {
    ...mapActions({
      makeProcesses: "makeProcesses",
      updateProcesses: "updateProcesses",
    }),
    loadData() {
      // if (!this.$auth.ensure('SCRAPPING_PRODUCT')) {
      //   return;
      // }
      this.loading = true;
      this.$apollo
        .query({
          query: CHECK_PROCESS_PROGRESS,
          fetchPolicy: 'no-cache'
        })
        .then((res) => {
          this.loading = false;
          if (res.data.checkProcessProgress.length === 0) {
            this.makeProcesses(null);
          } else {
            this.followProcessProgress();
            this.makeProcesses(res.data.checkProcessProgress);
          }
        }).catch(err => {
          console.log(err)
          this.loading = false;

        });
    },
    followProcessProgress() {
      this.$apollo
        .subscribe({
          query: FOLLOW_PROCESS_PROGRESS,
        })
        .subscribe({
          next: (result) => {
           this.updateProcesses(result.data.followProcessProgress);
          },
          error: (error) => {
            console.error('Subscription error:', error);
          },
        });
    },
  },
  created() {
    this.loadData();
  },
};
</script>
<style>
.big-box {
  max-height: 50vh;
  overflow-y: scroll;
}

.box {
  display: block;
  padding: 15px;
  background-color: #fff;
  top: 50%;
  z-index: 9;
}

.menu-processes {
  min-width: auto !important;
}
</style>
